export const MARKETPLACE_PATH = '/services';
export const MP_GTM_ID = 'GTM-5Z4N93N';
export const REDIRECTION_OVERLAY_ID = 'redirection-overlay';
export const FAVICON_IMG =
  'https://assets1.cleartax-cdn.com/cleartax/images/1644906212_clearfavicon.png';
export const SEO_CONFIG = {
  site_name: 'cleartax',
  title: 'Marketplace',
  description:
    'File Income Tax Returns online with ClearTax. ClearTax is fast, safe and easy to use. ClearTax handles all cases of  Income from Salary, Interest Income, Capital Gains, House Property, Business and Profession. ClearTax maximize your deductions by handling all deductions under Section 80 like section 80C, 80D, 80CCF, 80G, 80E, 80U and the rest. You can use your digital  signature to e-file. Our products are trusted by hundreds of CAs and corporations for filing taxes and TDS',
  locale: 'en',
};
export const CLEARTAX_DOMAIN = process.env.NEXT_PUBLIC_APP_DOMAIN;
export const VERTICAL_SCROLL_OFFSET = 280;
export const DESKTOP_NAV_SCROLL_OFFSET = -70;
export const NEXT_REDIRECT_OBJECT_HOMEPAGE = {
  redirect: {
    permanent: false,
    destination: `/services`,
  },
};
export const SEARCH_RESULTS_TO_SHOW = 5;
export const SANITIZE_HTML_DEFAULT_TAGS = [
  'address',
  'article',
  'aside',
  'footer',
  'header',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hgroup',
  'main',
  'nav',
  'section',
  'blockquote',
  'dd',
  'div',
  'dl',
  'dt',
  'figcaption',
  'figure',
  'hr',
  'li',
  'main',
  'ol',
  'p',
  'pre',
  'ul',
  'a',
  'abbr',
  'b',
  'bdi',
  'bdo',
  'br',
  'cite',
  'code',
  'data',
  'dfn',
  'em',
  'i',
  'kbd',
  'mark',
  'q',
  'rb',
  'rp',
  'rt',
  'rtc',
  'ruby',
  's',
  'samp',
  'small',
  'span',
  'strong',
  'sub',
  'sup',
  'time',
  'u',
  'var',
  'wbr',
  'caption',
  'col',
  'colgroup',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'tr',
];

export const SESSION_STORAGE_KEYS = {
  USERNAME: 'username',
};

export const REDIRECTION_TEMP_MAP: Record<string, string> = {
  'salary-e-filing': 'salary-e-filing-premium',
  'business-tax-efiling-regular': 'business-tax-efiling-presumptive',
  'capital-gains-e-filing': 'capital-gains-e-filing-plan',
};
